import type { ErrorInfo } from "react";
import type { FCIError } from "@searchui-searchforms/shared/fci";
import { useFCIDetailsContext } from "./fci-details-context";
import { logFCI } from "./logFCI";

export const useErrorBoundaryLogger = () => {
    const details = useFCIDetailsContext();

    return (errorType: FCIError) => (error: unknown, errorInfo: ErrorInfo) => {
        logFCI({
            errorType,
            errorInfo: `ErrorBoundary caught an error: ${error}`,
            details: {
                stack: error instanceof Error ? error.stack : undefined,
                componentStack: errorInfo.componentStack ?? undefined,
                ...details,
            },
        });
    };
};
